import '../../../stylesheets/dashboards/dashboards.css'
import '../../../stylesheets/dashboards/transaction-comps.css'

const MetricPaletteSections = (props) => {
    const { sections, tiles, selectedTileIds, draggedTileId, handleDragStart, handleTouchStart, handleTouchMove, handleTouchEnd } = props
    
    return (
        <>
            { sections.map(section => (
                <div key={section.id} className="palette-section-container">
                    <div className="palette-section-label"> {section.name} </div>
                    <div className="palette-section-tiles-grid-container">
                        {tiles.filter(tile => !selectedTileIds.includes(tile.id)).map(tile => {
                            if(!section.ids.includes(tile.id)) return
                            return (
                                <div
                                    key={tile.id}
                                    className={`transaction-tile ${draggedTileId === tile.id ? 'dragging' : ''}`} // stacking 'dragging' adds very light css property giving slight opacity if drag event has begun for this tile our of metric pallette give tile here in metric palette a slight opacity
                                    draggable="true"
                                    onDragStart={(e) => handleDragStart(e, tile.id)}
                                    onTouchStart={(e) => handleTouchStart(e, tile.id)}
                                    onTouchMove={handleTouchMove}
                                    onTouchEnd={handleTouchEnd}
                                >
                                    {tile.name}
                                </div>
                            )
                        })}
                    </div>
                </div>
            ))} 
        </>       
    )
}

export default MetricPaletteSections;